import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';

const VerificarEmail = () => {
  const [searchParams] = useSearchParams();
  const [estado, setEstado] = useState('verificando'); // verificando | exitoso | error
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setEstado('error');
      setMensaje('El enlace de verificación no es válido.');
      return;
    }

    api.get(`/auth/verificar-email?token=${token}`)
      .then(() => setEstado('exitoso'))
      .catch(err => {
        setEstado('error');
        setMensaje(err.response?.data?.error || 'El enlace es inválido o ya fue utilizado.');
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 50%, #eff6ff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '2.5rem 2rem',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ fontSize: '1.4rem', fontWeight: '800', color: '#3b82f6', marginBottom: '1.5rem' }}>
          🎯 FactuTracks
        </div>

        {estado === 'verificando' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <h2 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#111827', marginBottom: '0.5rem' }}>
              Verificando tu cuenta...
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Un momento por favor</p>
          </>
        )}

        {estado === 'exitoso' && (
          <>
            <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ fontSize: '1.3rem', fontWeight: '800', color: '#065f46', marginBottom: '0.5rem' }}>
              ¡Cuenta verificada!
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1.75rem' }}>
              Tu correo ha sido confirmado exitosamente.<br />
              Ya puedes iniciar sesión y comenzar a usar FactuTracks.
            </p>
            <Link
              to="/login"
              style={{
                display: 'inline-block',
                background: '#3b82f6',
                color: 'white',
                padding: '0.85rem 2rem',
                borderRadius: '10px',
                fontWeight: '700',
                fontSize: '1rem',
                textDecoration: 'none',
              }}
            >
              Iniciar sesión
            </Link>
          </>
        )}

        {estado === 'error' && (
          <>
            <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>❌</div>
            <h2 style={{ fontSize: '1.2rem', fontWeight: '800', color: '#dc2626', marginBottom: '0.5rem' }}>
              Enlace inválido
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1.75rem' }}>
              {mensaje}
            </p>
            <Link
              to="/login"
              style={{
                display: 'inline-block',
                background: '#3b82f6',
                color: 'white',
                padding: '0.85rem 2rem',
                borderRadius: '10px',
                fontWeight: '700',
                fontSize: '1rem',
                textDecoration: 'none',
              }}
            >
              Ir al login
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerificarEmail;
